import { render } from "./pressAbout.vue?vue&type=template&id=3f0b4c1c&scoped=true"
import script from "./pressAbout.vue?vue&type=script&lang=js"
export * from "./pressAbout.vue?vue&type=script&lang=js"

import "./pressAbout.vue?vue&type=style&index=0&id=3f0b4c1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0b4c1c"]])

export default __exports__